import { EBuildingLiftType } from 'shared/types/filters/advanced/buildingLiftTypesType';

export const mapBuildingLiftTypesTypeLabel = {
  [EBuildingLiftType.Passenger]: 'Пассажирский',
  [EBuildingLiftType.Service]: 'Грузовой',
  [EBuildingLiftType.Telpher]: 'Тельфер',
};
